var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "video-com" }, [
    _c("video", {
      staticClass: "video",
      attrs: {
        src: _vm.src,
        "x5-playsinline": "",
        playsinline: "",
        "webkit-playsinline": "",
        preload: "",
        loop: "",
        autoplay: "",
        controls: "",
        width: "100%",
        poster: _vm.poster
      }
    }),
    _c("div", { staticClass: "top-bar_hidden " }, [
      _c(
        "button",
        {
          staticClass: "icon-menu closed",
          on: {
            click: function($event) {
              return _vm.$router.push("/")
            }
          }
        },
        [
          _c("span", { staticClass: "svgMenu line1" }),
          _c("span", { staticClass: "svgMenu line2" }),
          _c("span", { staticClass: "svgMenu line3" })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-819da956", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-819da956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/video/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-819da956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/video/index.vue
// module chunks = 16